import { Environment } from "./type";

export const environment: Environment = {
  production: true,
  sentryDsn: "https://38019c7053a0666c474ca7ba551550eb@o515678.ingest.us.sentry.io/4506948733108224",
  SENTRY_ORG: "rzp",
  SENTRY_PROJECT: "mastercard-all",
  apiUrlBsV1: 'https://api.poshvine.com/bs/v1/',
  apiUrlCsV1: 'https://api.poshvine.com/cs/v1/',
  apiUrlPaV1: 'https://api.poshvine.com/pa/v1/',
  apiUrlPsV1: 'https://api.poshvine.com/ps/v1/',
  apiUrlBsInternal: 'https://api.poshvine.com/bs/internal/',
  clientId: '2a0127dc-09f0-4135-878a-d2378503f6cb',
  projectId: '3ba1b73d-ab08-4f53-bd77-ea2226c61a7f',
  gmApiKey: 'AIzaSyAXREnbpzSGulf8xS5J43tsYwrbBFltR7k',
  secretKey: '000102030405060708090a0b0c0d0e0f',
  ipstackKey: '022375a36968cebce87e10e1c6447ef6'
};
